/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ILinks {
  linkDescription?: string;
  downloadLink?: string;
}

export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
  links: ILinks[];
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'Eid with Geoffrey',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MDvdB',
    textDescription:
      'Geoffrey is preparing for Eid, what about you kids? Let us do some gifting ideas together, just print the sheets and enjoy! Make your own Edyia envelop, or a box to hide your favorite candies inside, or cut a lovely toppings to be placed over every cupcake.<br/><br/>Where are our creative kids? Come on let’s celebrate! Eid Mubarak<br/><br/>Parents, use #LetsPlaySaudi on social media so we can see how they did it!<br/><br/>Geoffrey is preparing for Eid, what about you kids? Let us do some gifting ideas together, just print the sheets and enjoy! Make your own Edyia envelop, or a box to hide your favorite candies inside, or cut a lovely toppings to be placed over every cupcake.<br/><br/>Where are our creative kids? Come on let’s celebrate! Eid Mubarak<br/><br/>Parents, use #LetsPlaySaudi on social media so we can see how they did it!<br/><br/>',
    links: [
      {
        linkDescription: 'DIY & Coloring ',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1Xs2',
      },
      {
        linkDescription: 'Coloring pages',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1ZY0',
      },
      {
        linkDescription: 'Connect Lines',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1Urk',
      },
      {
        linkDescription: 'Words Search',
        downloadLink:
          'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1ZXZ',
      },
    ],
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>

            <div className='table-container'>
              <table className='table'>
                {this.printPage.links.map((item) => (
                  <tr>
                    <td>{item.linkDescription}</td>
                    <td>
                    <a href={item.downloadLink} className='print-download-link' target='_blank'>download
                    </a>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
